import React from "react";
import SkillsetCard from "../elements/Card/Skillset";
import Title from "../elements/Title";
import {
  FaHtml5,
  FaFigma,
  FaReact,
  FaJs,
  FaCss3Alt,
  FaBootstrap,
} from "react-icons/fa";
import { DiMongodb } from "react-icons/di";
import Fade from "react-reveal";
import { SiTailwindcss, SiTypescript, SiNextdotjs } from "react-icons/si";
function Skillset(props, ref) {
  return (
    <section
      className="text-white px-3 py-12 md:pt-40 md:pb-48  bg-black"
      ref={ref}
    >
      <div className="container mx-auto">
        <Title
          title="Tech &amp; Tools"
          caption="Here are several techs that I've used"
        />
        <div className="flex flex-wrap justify-center md:pt-6">
          <Fade bottom>
            <SkillsetCard
              title="HTML"
              skillsetIcon={<FaHtml5 size="1.85rem" />}
            />
            <SkillsetCard
              title="CSS"
              skillsetIcon={<FaCss3Alt size="1.85rem" />}
            />
            <SkillsetCard
              title="React"
              skillsetIcon={<FaReact size="1.85rem" />}
            />
            <SkillsetCard
              title="Tailwind"
              skillsetIcon={<SiTailwindcss size="1.85rem" />}
            />
            <SkillsetCard
              title="Figma"
              skillsetIcon={<FaFigma size="1.85rem" />}
            />
            <SkillsetCard
              title="ExpressJs"
              skillsetIcon={<FaJs size="1.85rem" />}
            />
            <SkillsetCard
              title="Typescript"
              skillsetIcon={<SiTypescript size="1.6rem" />}
            />
            <SkillsetCard
              title="NextJS"
              skillsetIcon={<SiNextdotjs size="1.85rem" />}
            />
            <SkillsetCard
              title="Bootstrap"
              skillsetIcon={<FaBootstrap size="1.85rem" />}
            />
            <SkillsetCard
              title="MongoDB"
              skillsetIcon={<DiMongodb size="1.85rem" />}
            />
          </Fade>
        </div>
      </div>
    </section>
  );
}

const refSkillset = React.forwardRef(Skillset);
export default refSkillset;
